import React, { useEffect, useState } from 'react';
import {
  Dialog, Button, Field, TextInput, RadioList, Banner,
} from '@NP-Webber/crm-kit/dist/next/index.js';
import api from '../services/api.js';
import { apiError } from '../next/ui';
import {
  OCCUPATION_OPTIONS, STUDY_FORMATS, isWorking, partnerLabel,
} from '../utils/memberStudy.js';

/**
 * עדכון סטטוס נבחן (מעקב נציגים): סטטוס → אם עמל הפרנסה / בעה"ב: חברותא או שיעור → שם החברותא / המג"ש (חובה).
 * member: { _id, version, firstName, lastName, occupation, studyFormat, studyPartner }; onSaved(updatedMember).
 */
export default function StudyStatusDialogNext({ member, onClose, onSaved }) {
  const [form, setForm] = useState({ occupation: '', studyFormat: '', studyPartner: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!member) return;
    setForm({ occupation: member.occupation || '', studyFormat: member.studyFormat || '', studyPartner: member.studyPartner || '' });
    setError('');
  }, [member]);

  const working = isWorking(form.occupation);
  const partner = form.studyPartner.trim();
  const valid = !!form.occupation && (!working || (form.studyFormat && partner));
  const occupations = [...OCCUPATION_OPTIONS, ...(member?.occupation && !OCCUPATION_OPTIONS.includes(member.occupation) ? [member.occupation] : [])];

  const save = async () => {
    if (!valid || saving) return;
    setSaving(true);
    setError('');
    try {
      const body = working
        ? { occupation: form.occupation, studyFormat: form.studyFormat, studyPartner: partner }
        : { occupation: form.occupation, studyFormat: '', studyPartner: '' };
      const { data } = await api.put(`/members/${member._id}`, { version: member.version, ...body });
      onSaved?.(data);
    } catch (e) {
      setError(e.response?.status === 409 ? 'הכרטיס עודכן בינתיים ממקום אחר — רעננו את הדו״ח ונסו שוב' : apiError(e, 'שגיאה בשמירת הסטטוס'));
    } finally {
      setSaving(false);
    }
  };

  const name = [member?.firstName, member?.lastName].filter(Boolean).join(' ');
  return (
    <Dialog
      open={!!member}
      onClose={() => !saving && onClose()}
      title={`סטטוס — ${name}`}
      icon="user"
      size="sm"
      footer={(
        <>
          <Button variant="ghost" disabled={saving} onClick={onClose}>ביטול</Button>
          <Button variant="primary" icon="check" disabled={saving || !valid} onClick={save}>{saving ? 'שומר…' : 'שמירה'}</Button>
        </>
      )}
    >
      <div className="nx-stack">
        {error ? <Banner tone="danger" icon="alert">{error}</Banner> : null}
        <Field label="סטטוס">
          <RadioList value={form.occupation} onChange={(v) => setForm((f) => ({ ...f, occupation: v }))} options={occupations.map((o) => ({ value: o, label: o }))} />
        </Field>
        {working ? (
          <Field label="לומד ב־">
            <RadioList value={form.studyFormat} onChange={(v) => setForm((f) => ({ ...f, studyFormat: v }))} options={STUDY_FORMATS.map((o) => ({ value: o, label: o }))} />
          </Field>
        ) : null}
        {working && form.studyFormat ? (
          <Field label={partnerLabel(form.studyFormat)}>
            <TextInput
              autoFocus
              value={form.studyPartner}
              placeholder={form.studyFormat === 'שיעור' ? 'מי מוסר את השיעור' : 'עם מי לומד'}
              onChange={(e) => setForm((f) => ({ ...f, studyPartner: e.target.value }))}
              onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
            />
          </Field>
        ) : null}
      </div>
    </Dialog>
  );
}
